import {Injectable} from "@angular/core";
import { Observable, throwError } from 'rxjs';
import {HttpClient, HttpEventType, HttpRequest} from "@angular/common/http";
import {catchError, filter, map} from "rxjs/operators";
import {environment} from "../../../../environments";
import {TranslateService} from "@ngx-translate/core";
import {saveAs} from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ManualService {
  private apiEndpoint: string;

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    ) {
      this.apiEndpoint = environment.apiUrl;
  }

  downloadManual(): Observable<number | undefined> {
    const fileName = 'Grip_manual_client.pdf';
    const req = new HttpRequest('GET', `${this.apiEndpoint}/Manual/DownloadBackOffice`, {
      reportProgress: true,
      responseType: 'blob'
    });
    return this.http.request<Blob>(req)
      .pipe(
        filter(event =>
          event.type === HttpEventType.DownloadProgress ||
          event.type === HttpEventType.Response
        ),
        map(event => {
          switch (event.type) {
            case HttpEventType.DownloadProgress:
              // Compute and show the % done:
              return  Math.round(100 * event.loaded / event.total);
            case HttpEventType.Response:
              saveAs(event.body, fileName);
              return undefined;
          }
        }),
        catchError(err => {
          if (err.errorcode) {
            return throwError(err.errorcode);
          }
          return throwError(this.translate.instant('BUSSINESSERRORS.ErrUnexpected'));
        })
      );
  }

}


